import React, { useState, useRef, useCallback } from "react";
import cn from "classnames";
import { isEmpty } from "lodash";
import QrReader from '@components/QrReader';
import Keyboard from "@components/KeyboardV2";
import { LABEL, CUSTOM_MESSAGES } from "../../../veriables";
import styles from "../serverAppPaymentScreens.module.scss";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import { ReactComponent as Coupon } from "@assets/images/Coupon.svg";
import { getObjectValue } from '@utility/utills';
import BarcodeScanner from "../../common/BarcodeScanner/index";
import { TouchableButton, TouchableDiv } from "../../common/Touchable/index";

const CouponScreen = ({
  authInfo,
  handleApplyOffer,
  handleCouponCancel,
  serverAppTheme,
  setErrorPopUp,
  isLandScape,
  showCheckSeat
}) => {
  // State Management
  const [inputs, setInputs] = useState({});
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const [errorMessage, setErrorMessage] = useState("");
  const [isScanModal, setIsScanModal] = useState(false);
  const [startScan, setStartScan] = useState(true);
  const [barCodeScan, setBarCodeScan] = useState(false);
  const keyboardType =
    authInfo?.loyaltyInfo?.keyboardStyle === 2
      ? "textWithoutNumericShift"
      : authInfo?.loyaltyInfo?.keyboardStyle === 1
        ? "numericWithBin"
        : "textWithoutNumeric";

  // Methods
  const barcodeFormat = getObjectValue(() => (authInfo?.loyaltyInfo?.barcodeFormat?.length > 0), false);
  const couponImage = JSON.parse(window.sessionStorage.getItem('themeProperties'))?.couponImageUrl;

  const getInputValue = (inputNameDat) => {
    return inputs[inputNameDat] || "";
  };

  const validation = (value) => {
    let error;
    return new Promise((resolve, reject) => {
      if (value?.couponCode?.length === 0 || !value.couponCode) {
        error = "Coupon code is required";
      }
      if (isEmpty(error)) {
        resolve();
      } else {
        reject(error);
      }
    });
  };

  const onClickBtn = useCallback((e) => {
    setErrorMessage("");
    const currentInputs = inputsRef.current;
    const value =
      e === "{bksp}"
        ? { ...currentInputs, couponCode: currentInputs["couponCode"]?.slice(0, -1) }
        : {
            ...currentInputs,
            couponCode: currentInputs["couponCode"]
              ? currentInputs["couponCode"].concat(e)
              : "".concat(e),
          };
    setInputs({
      ...currentInputs,
      couponCode: value.couponCode,
    });
  }, []);

  const handleApplyCode = (data) => {
    const updatedData = {
      offerId: data.couponCode,
      isCoupon: true,
    };

    validation(inputs)
      .then(() => {
        const types = "type";
        handleApplyOffer(updatedData, types);
        setInputs({
          ...inputs,
          couponCode: "",
        });
      })
      .catch((error) => {
        setErrorPopUp({
          res: error,
          noErrorTxt: true,
        });
      });
  };

  const handleBlur = () => {
    const element = document.querySelector(`#couponCode`);
    element.blur();
  };

  const handleQrCode = (data) => {
  const updatedData = {
      offerId: data,
    isCoupon: true,
  };

    const types = "qrcode";
    handleApplyOffer(updatedData, types);
};

  const handleScan = async (scanData) => {
    if (scanData && scanData !== "") {
    setStartScan(false);
      handleQrCode(scanData);
    setIsScanModal(false);
  }
};

  const handleBarCodeScan = (data) => {
    const code = data ?? "";
    if (code && code != "") {
      setBarCodeScan(false);
      handleQrCode(code);
      setInputs((prev) => ({ ...prev, couponCode: code }))
    }
  }
  const CouponCondition =
    authInfo?.loyaltyInfo?.couponMethods == null ||
    authInfo?.loyaltyInfo?.couponMethods?.includes("type") ||
    authInfo?.loyaltyInfo?.couponMethods?.includes("");

  const QRCondition = authInfo?.loyaltyInfo?.couponMethods?.includes("qrcode");

  let type = authInfo?.loyaltyInfo?.couponMethods?.includes('type');
  let qrCode = authInfo?.loyaltyInfo?.couponMethods?.includes('qrcode');
  let barCode = (authInfo?.loyaltyInfo?.couponMethods?.includes('barcode') && authInfo?.loyaltyInfo?.barcodeFormat?.length > 0)
const getQrButtonLayout = () => {
  if (type && qrCode && barCode) return isLandScape ? 'col-4 pl-1 pr-0' : 'col-6 pl-1 pr-0';
  if (type && qrCode && !barCode) return isLandScape ? 'col-8 px-0' : 'col-12 px-0';
  if (!type && barCode) return 'col-6 pl-1 pr-0';
  return isLandScape ? 'col-6 px-0' : 'col-12 px-0';
};

const getBarCodeBtnLayout = () => {
  if (type && qrCode && barCode) return isLandScape ? 'col-4 pl-0 pr-1' : 'col-6 pl-0 pr-1';
  if (type && qrCode && !barCode) return 'col-6 pl-0 pr-1';
  if (type && !qrCode && barCode) return isLandScape ? 'col-8 px-0' : 'col-12 px-0';
  if (!type && qrCode) return 'col-6 pl-0 pr-1';
  return isLandScape ? 'col-6 px-0' : 'col-12 px-0';
};

  // HTML and CSS
  return (
      <div className={cn("col-12 p-0 mx-0 justify-content-center h-100 position-relative")}>
      {!isLandScape && (
        couponImage ? (
          <div className="col-12 px-0 h-20 pb-2 pt-2">
            <img src={couponImage} className="w-100 h-100" style={{objectFit:'cover'}} alt="couponImage" />
          </div>
        ) : (
          <div className="col-12 px-0 h-20 pb-2 pt-2">
            <div className="col-12 row mx-0 px-0 h-100" style={{ backgroundColor: serverAppTheme?.scp_bg }}>
              <div className="col-6 px-0 d-flex justify-content-center align-items-center fs_24 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                Coupon
              </div>
              <div className="col-6 px-0 d-flex justify-content-center align-items-center">
                <Coupon />
              </div>
            </div>
          </div>
        )
      )}      
          {!isLandScape && 
        <div
          className="h-9 fs_32 fw-600 d-flex justify-content-center"
          style={{ color: serverAppTheme?.primary_text }}
        >
          {CUSTOM_MESSAGES().ENTER_COUPON_CODE}
        </div>
        }
        {!isScanModal ? !barCodeScan ?
            <div className={cn("col-12 px-0 row mx-0 pb-2",isLandScape ? (!barCode && !qrCode ?  showCheckSeat() ? 'h-77 mt-3' : 'h-75 mt-27' : showCheckSeat() ? 'h-70 mt-3' : 'h-70 mt-27') : 'h-50')}>
              <div className="col-12 px-0 h-15">
                {!(authInfo?.loyaltyInfo?.couponMethods?.length == 1 && authInfo?.loyaltyInfo?.couponMethods?.includes('qrcode')) && (
                  <div
                    className={cn(
                      "col-12 p-0 position-relative br-5 mb-1", isLandScape && 'd-flex justify-content-center align-items-center'
                    )}
                  >
                    <input
                      id="couponCode"
                      type="text"
                      name="couponCode"
                      className={cn("fs_20 fw-400 text-left",isLandScape ? 'col-8' : 'col-12')}
                      style={{
                        border: "none",
                        height: "56px",
                        background: serverAppTheme?.inputBg,
                        borderBottom: serverAppTheme?.inputBorder_Bottom,
                        color: serverAppTheme?.primary_text,
                        "--placeholder-color": serverAppTheme?.input_placeholder,
                      }}
                      placeholder={CUSTOM_MESSAGES().ENTER_COUPON_CODE}
                      value={getInputValue("couponCode")}
                      onFocus={() => {
                        handleBlur();
                      }}
                    />
                    {getInputValue("couponCode") !== "" && (
                      <TouchableDiv
                        className={cn(isLandScape ? styles.clearStyleLandscape : styles.clearStyle)}
                        tabIndex="0" 
                        role="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setInputs({ ...inputs, couponCode: "" });
                        }}
                      >
                        <Cross fill={serverAppTheme?.iconcolor} />
                      </TouchableDiv>
                    )}
                  </div>
                )}
                {errorMessage.length > 0 && (
                  <div className="text-right px-0 col-12 fs-12 text-primary">
                    {errorMessage}
                  </div>
                )}
              </div>
              {CouponCondition && (
                <div
                  className={cn(
                    "w-100 mt-3 pt-1",isLandScape ? (!barCode && !qrCode ? 'h-84' : 'h-75') : 'h-85'
                  )}
                >
                  <Keyboard
                    onClickBtn={onClickBtn}
                    type={keyboardType}
                    customClass="fs-30"
                    onlySurveyText={true}
                    screenType="couponPopUp"
                  />
                </div>
              )}
            </div>
          : (
            <>
              {barCodeScan && (
                <BarcodeScanner
                  handleBarCodeScan={handleBarCodeScan}
                  closeBarcodeScanner = {() => setBarCodeScan(false)}
                  serverAppTheme={serverAppTheme}
                  isLandScape={isLandScape}
                  showCheckSeat={showCheckSeat}
                />
              )}
            </>
          ) : (
          <div
            className={cn(
              "col-12 my-1 py-2 large-input px-0 justify-content-center d-flex",
            )}
          >
            <div className={cn("align-items-baseline row justify-content-around", isLandScape ? (showCheckSeat() ? 'col-8' : 'col-9') : 'col-12')}>
              {startScan && (
                <QrReader
                  onScan={handleScan}
                  style={{ width: isLandScape ? "63%" : "75%" }}
                  onError={(err) => {
                    setErrorPopUp({
                      res: err.message
                    })
                  }}
                />
              )}
              <div className="text-center" style={{ fontSize: "2rem" }}>
                Please scan QR code
              </div>
            </div>
            <TouchableDiv
              className="px-2 text-right fs-28 position-absolute"
              style={{ right: isLandScape ? "205px" : "20px" , top: isLandScape ? 0 : ''}}
            >
              <i
                onClick={() => {
                  setIsScanModal(false);
                }}
                role="presentation"
                className="fa fa-times"
                aria-hidden="true"
              />
            </TouchableDiv>
          </div>
        )}
        <div
          className={cn(
            "align-content-end d-flex row h-18 w-100 mx-0 position-absolute",
          )}
          style={{bottom: isLandScape ? (!barCode || !qrCode ? showCheckSeat() ? '11px' : '12px' : showCheckSeat() ? '15px' : 0) : 0}}
        >
          <div className={cn("col-12 px-0 d-flex", isLandScape ? 'justify-content-center' : 'justify-content-around')}>
             {authInfo?.loyaltyInfo?.couponMethods?.includes('barcode') && barcodeFormat && (
              <div className={cn("pb-2", getBarCodeBtnLayout())}>
                <TouchableButton
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsScanModal(false);
                    setBarCodeScan(true);
                  }}
                  className={cn("px-0 fw-600 fs_28 w-100 btn-ripple btnBorder od-primary-btn-bg-color od-primary-btn-font-color", !isLandScape && 'btn68')}
                  style={{
                    color: serverAppTheme?.btn_font_color,
                    background: serverAppTheme?.secondaryBtn,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CS_SCAN_BAR_CODE}
                </TouchableButton>
                </div>
              )}
            {QRCondition && (
              <div className={cn("pb-2", getQrButtonLayout())}>
                <TouchableButton
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsScanModal(true);
                    setStartScan(true);
                    setBarCodeScan(false)
                  }}
                  className={cn("px-0 fw-600 fs_28 w-100 btn-ripple btnBorder od-primary-btn-bg-color od-primary-btn-font-color", !isLandScape && 'btn68')}
                  style={{
                    color: serverAppTheme?.btn_font_color,
                    background: serverAppTheme?.secondaryBtn,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CS_SCAN_QR_CODE}
                </TouchableButton>
              </div>
            )}
          </div>
          <div className={cn("col-12 px-0 d-flex", isLandScape ? "justify-content-center py-12" : "justify-content-around")}>
            <div
              className={cn(
                CouponCondition ? (isLandScape ? "col-4 pl-0 pr-1" : "col-6 pl-0 pr-1") : isLandScape ? "col-6 px-0" : "col-12 px-0",
              )}
            >
              <TouchableButton
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleCouponCancel();
                }}
                className={cn("px-0 fw-600 fs_28 w-100 btn-ripple btnBorder od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color", !isLandScape && 'btn68')}
                style={{
                  color: serverAppTheme?.cancleBtn_font,
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                }}
                rippleEffect={true}
              >
                {LABEL().CS_CANCEL}
              </TouchableButton>
            </div>
            {CouponCondition && (
              <div className={cn("px-0 pl-1", isLandScape ? "col-4" : "col-6")}>
                <TouchableButton
                  type="submit"
                  onClick={(e) => {e.preventDefault(); handleApplyCode(inputs);}}
                  className={cn("fw-600 fs_28 w-100 btn-ripple btnBorder od-primary-btn-bg-color od-primary-btn-font-color", !isLandScape && 'btn68')}
                  style={{
                    color: serverAppTheme?.btn_font_color,
                    background: serverAppTheme?.secondaryBtn,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CS_APPLY_CODE}
                </TouchableButton>
              </div>
            )}
          </div>
        </div>
      </div>
  );
};

export default CouponScreen;
